import { useState } from 'react';

const useSearch = (defaultSearch = '') => {
  const [searchTerm, setSearchTerm] = useState(defaultSearch);
  const [isSearching, setIsSearching] = useState(false);

  const cancelSearch = () => {
    setSearchTerm('');
    setIsSearching(false);
  };

  return {
    searchTerm,
    setSearchTerm,
    isSearching,
    setIsSearching,
    cancelSearch,
  };
};

export default useSearch;

